module.exports = __webpack_public_path__ + "img/left_md_3.d928ac44.jpg";